import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getInvoiceListRequest } from 'redux/reducers/invoiceManagement/reducer';
import {
	selectInvoiceListData,
	selectInvoiceListLoading,
} from 'redux/reducers/invoiceManagement/selectors';
import { Page } from 'layouts/Page';
import { InvoiceDetail } from 'components/InvoiceManagement/InvoiceDetail';

export const InvoiceManagementDetailPage: FC = () => {
	const { invoiceNumber } = useParams<{ invoiceNumber: string }>();
	const dispatch = useDispatch();
	const invoiceListData = useSelector(selectInvoiceListData);
	const invoiceListLoading = useSelector(selectInvoiceListLoading);

	const rawFirst = invoiceListData[0];
	const invoice = invoiceListLoading
		? null
		: rawFirst != null && String(rawFirst.invoice_number) === String(invoiceNumber ?? '')
			? rawFirst
			: null;

	useEffect(() => {
		if (!invoiceNumber) return;
		dispatch(
			getInvoiceListRequest({
				tableName: 'invoice_list_info',
				orderBy: ['timestamp desc'],
				filter: [{ name: 'invoice_number', value: invoiceNumber, comparator: '=' }],
				page: { size: 1, from: 0 },
			}),
		);
	}, [dispatch, invoiceNumber]);

	return (
		<Page title={`Invoice ${invoiceNumber ?? ''} – EAS Control Center`}>
			<InvoiceDetail invoice={invoice} loading={invoiceListLoading} />
		</Page>
	);
};
